import React from "react";

import * as S from "./styles";
import Header from "../../components/Header";
import { Outlet } from "react-router";
import { Col, Container, Row } from "reactstrap";


function Home() {

  return (
      <S.Container>
        <Header />
        <Container>
          <Row>
            <Col>
              <Outlet />
            </Col>
          </Row>
        </Container>
      </S.Container>
  );
}

export default Home;
